module.exports = __webpack_public_path__ + "img/bg-topup.714a3c69.svg";